import { render, staticRenderFns } from "./UPreRegisterComp.vue?vue&type=template&id=1971a262&scoped=true&"
import script from "./UPreRegisterComp.vue?vue&type=script&lang=ts&"
export * from "./UPreRegisterComp.vue?vue&type=script&lang=ts&"
import style0 from "./UPreRegisterComp.vue?vue&type=style&index=0&id=1971a262&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1971a262",
  null
  
)

export default component.exports